import mapMarkerIconFactory from "../../../../../common/components/map/marker/map-marker-icon.factory";
import MapMarker from "../../../../../common/components/map/types/map-marker";
import MapRoute from "../../../../../common/components/map/types/map-route";
import { SearchRoadRoutingResponseRouteGeometryCoordinate } from "../../../../../common/utils/search-road-route/search-road-routing.response";
import {
  OrderOptimizerCargoDetailsItemOrders,
  OrderOptimizerCargoDetailsItemSteps,
  OrderOptimizerCargoDetailsItemStepsOrdersPoints,
} from "./types/order-optimizer-cargo-details-item";

const createMapMarker = (
  address: OrderOptimizerCargoDetailsItemStepsOrdersPoints,
  addressNum: number
) => {
  const signature = `${addressNum + 1}`;

  const markerIcon = mapMarkerIconFactory.createIcon({
    className: "map_marker standard",
    content: signature,
  });

  const newMapMarker: MapMarker = {
    coordinate: {
      latitude: address.lat,
      longitude: address.lon,
    },
    icon: markerIcon,
  };

  return newMapMarker;
};

const createMapMarkers = (
  steps: OrderOptimizerCargoDetailsItemSteps,
  orders: OrderOptimizerCargoDetailsItemOrders[],
  hiddenOrders: number[]
): MapMarker[] => {
  const mapMarkers: MapMarker[] = [];
  let addressNum = 0;

  steps.orders.forEach((step, orderIndex) => {
    const order = orders[orderIndex];
    if (!order || hiddenOrders.includes(order.humanId)) {
      return;
    }

    step.points.forEach((point) => {
      const marker = createMapMarker(point, addressNum);
      mapMarkers.push(marker);
      addressNum++;
    });
  });

  return mapMarkers;
};

const createMapRoute = (
  routesResponseGeometryCoordinates: SearchRoadRoutingResponseRouteGeometryCoordinate[],
  color: string
): MapRoute => {
  return {
    waypoints: routesResponseGeometryCoordinates.map((coordinate) => {
      return {
        latitude: coordinate[1],
        longitude: coordinate[0],
      };
    }),
    options: {
      color: color,
    },
  };
};

const orderOptimizerCargoDetailsRouteFactory = {
  createMapMarkers,
  createMapRoute,
};

export default orderOptimizerCargoDetailsRouteFactory;
